import { render, staticRenderFns } from "./project_manage.vue?vue&type=template&id=4aaa6347&scoped=true"
import script from "./project_manage.vue?vue&type=script&lang=js"
export * from "./project_manage.vue?vue&type=script&lang=js"
import style0 from "./project_manage.vue?vue&type=style&index=0&id=4aaa6347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa6347",
  null
  
)

export default component.exports